import { ContentCopy, Delete, AutoAwesome } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);

  const d = data || {};
  const nomes = { openai: "GPT", gemini: "Gemini", anthropic: "Claude", openrouter: "OpenRouter" };
  const label = `${nomes[d.provider] || "IA"}: ${d.model || "modelo nao definido"}`;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "250px",
        maxWidth: "250px",
        width: "250px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: "2px solid #e5e7eb",
        boxShadow: isHovered
          ? "0 12px 32px rgba(0,0,0,0.12)"
          : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(135deg, #10b981, #059669)",
          width: "16px",
          height: "16px",
          top: "24px",
          left: "-10px",
          cursor: "pointer",
          border: "3px solid #ffffff",
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          display: "flex",
          gap: "4px",
          zIndex: 10,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s",
        }}
      >
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ContentCopy sx={{ width: "14px", height: "14px", color: "#6b7280" }} />
        </div>
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#fee2e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Delete sx={{ width: "14px", height: "14px", color: "#dc2626" }} />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #10b981, #059669)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "10px",
          }}
        >
          <AutoAwesome sx={{ color: "#fff", width: "18px", height: "18px" }} />
        </div>
        <div style={{ fontWeight: 700, fontSize: "15px", color: "#111827" }}>
          Bloco de IA
        </div>
      </div>

      <div
        style={{
          fontSize: "12px",
          color: "#4b5563",
          background: "#f9fafb",
          borderRadius: "8px",
          padding: "8px",
        }}
      >
        {label}
      </div>

      <div style={{ marginTop: 6, fontSize: 11, color: "#6b7280" }}>
        {`salva em {{${d.answerKey || "ai.response"}}}`}
        {d.autoSend ? " · responde ao cliente" : ""}
      </div>

      {(d.smartConditions || []).length > 0 && (
        <div style={{ marginTop: 8 }}>
          {(d.smartConditions || []).map((c, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 11,
                color: "#6b7280",
                marginTop: 3,
              }}
            >
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #10b981, #059669)",
                  display: "inline-block",
                  flexShrink: 0,
                }}
              />
              {c.output || `saída ${i + 1}`}
            </div>
          ))}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 11,
              color: "#6b7280",
              marginTop: 3,
            }}
          >
            <span
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #9ca3af, #6b7280)",
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            {d.defaultOutput || "padrão"}
          </div>
        </div>
      )}

      {(d.smartConditions || []).map((c, i) => (
        <Handle
          key={`sc-${i}`}
          type="source"
          position="right"
          id={`smart_${i}`}
          style={{
            background: "linear-gradient(135deg, #10b981, #059669)",
            border: "2px solid #ffffff",
            width: "12px",
            height: "12px",
            right: "-6px",
            top: `${45 + i * 9}%`,
            bottom: "auto",
            transform: "translateY(-50%)",
          }}
          isConnectable={isConnectable}
        />
      ))}

      {(d.smartConditions || []).length > 0 && (
        <Handle
          type="source"
          position="right"
          id="smart_default"
          style={{
            background: "linear-gradient(135deg, #9ca3af, #6b7280)",
            border: "2px solid #ffffff",
            width: "12px",
            height: "12px",
            right: "-6px",
            top: `${45 + (d.smartConditions || []).length * 9}%`,
            bottom: "auto",
            transform: "translateY(-50%)",
          }}
          isConnectable={isConnectable}
        />
      )}

      {(d.smartConditions || []).length === 0 && (
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(135deg, #10b981, #059669)",
          border: "2px solid #ffffff",
          width: "14px",
          height: "14px",
          right: "-7px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
        isConnectable={isConnectable}
      />
      )}
    </div>
  );
});
